


































import { Component, Vue, Watch } from 'vue-property-decorator'
import PageHead from '@/components/PageHead.vue'
import { Notify } from '@/helpers/Notify'
import { Api } from '@/fetch/Api'
import store from '@/store'

@Component({
  components: {
    PageHead,
  },
})
export default class PageEdit extends Vue {
  pageTitle = 'Edit llms.txt'
  callInProgress = false
  llms_content = null
  urlScheme = window.location.protocol
  domain = window.location.hostname.replace(/www./i, '')

  created() {
    this.fetchDomainLlmsText()
  }

  @Watch('$route.params.id')
  onVariable() {
    this.fetchDomainLlmsText()
  }

  public async fetchDomainLlmsText() {
    this.callInProgress = true
    try {
      const domainLlmsTextResponse = await Api.getDomainLlmsText(parseInt(this.$route.params.id))
      this.llms_content = domainLlmsTextResponse.llms_content
      this.callInProgress = false
    } catch (e) {
      this.callInProgress = false
      Notify.create({
        type: 'error',
        title: 'Something went wrong...',
        text: e,
      })
    }
  }

  public async saveChanges() {
    this.callInProgress = true
    try {
      await Api.updateDomainLlmsText(this.domain, this.llms_content || '')
      this.callInProgress = false
      store.commit('toggleFlag', 'reloadNav')
      Notify.create({
        type: 'success',
        title: 'Saved!',
        text: 'Content for llms.txt updated!',
      })
    } catch (e) {
      this.callInProgress = false
      Notify.create({
        type: 'error',
        title: 'Something went wrong...',
        text: e,
      })
    }
  }
}
